import { getSectionToInsert } from "@/lib/singularity/singularity";
import { copyNode, findNode, getBlankTree, moveNode } from "@/lib/tree/tree";
import { SectionDescription } from "@/types/singularity";
import { getFieldsToComplete, processCompletion } from "@/lib/ai/ai";
import { formatFieldsForOpenAI, getPrompt } from "@/lib/ai/prompts";
import { getPromptInfoFromNode } from "@/lib/singularity/util";
import { globalStore } from "@/store/store";
import { Tree, TreeNode } from "@/types/tree";
import { FieldToComplete } from "@/lib/ai/types";
import lodash from "lodash";

export function getChatMessagesToRequestSectionPopulation(section: TreeNode) {
  const promptInfo = getPromptInfoFromNode(section);
  const fields = getFieldsToComplete(section);
  const fieldsToFill = formatFieldsForOpenAI(fields);
  return getPrompt(fieldsToFill, promptInfo, globalStore.aiSettings.prompt);
}

export function getTreeFromSectionDescriptions(
  sectionDescriptions: SectionDescription[]
) {
  const tree = getBlankTree();
  for (let index = 0; index < sectionDescriptions.length; index++) {
    const section = sectionDescriptions[index];
    const sectionToInsert = getSectionToInsert(section);
    if (!sectionToInsert) continue;
    const copiedNode = copyNode(tree, sectionToInsert);
    moveNode(tree, copiedNode.id, tree.root.id, index);
  }
  return tree;
}

export function populatePhantomSectionWithAiData(
  sectionNode: TreeNode,
  jsonCompletion: string,
  fieldsToComplete: FieldToComplete[],
  containingTree: Tree
) {
  const parsedCompletion = processCompletion(jsonCompletion, fieldsToComplete);

  if (!parsedCompletion.elements.length) {
    throw new Error("No elements were returned from OpenAI API.");
  }

  parsedCompletion.elements.forEach(completedField => {
    const nodeToModify = findNode(containingTree, completedField.nodeId);
    if (nodeToModify) {
      lodash.set(
        nodeToModify.data.properties,
        completedField.controlPath,
        completedField.value
      );
    }
  });

  const promptInfo = getPromptInfoFromNode(sectionNode);
  promptInfo.singularity.shouldGenerateOnInitialLoad = false;
  promptInfo.singularity.unsplashKeywords = parsedCompletion.unsplash_keywords;
  lodash.set(sectionNode.data.properties, "meta.promptInfo", promptInfo);

  return sectionNode;
}
